export default "__VITE_ASSET__X48G$973__"